import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

type SiteLinkProps = {
  /** A route ("/about"), a route with a section ("/#team"), a section on this page ("#team"), or a full URL. */
  to: string
  className?: string
  children: ReactNode
}

/** Routes go through the router; same-page sections and other sites are plain links. */
export const SiteLink = ({ to, className, children }: SiteLinkProps) =>
  to.startsWith('/') ? (
    <Link to={to} className={className}>
      {children}
    </Link>
  ) : (
    <a href={to} className={className}>
      {children}
    </a>
  )
